import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateNeighbourhoodPerks } from './get-neighbourhood-perks'

export const deleteNeighbourhoodPerk = async (id: number) => {
  await authAPI.delete(`/neighbourhood/${id}`)
}

export const useDeleteNeighbourhoodPerk = () => {
  const invalidatePerks = useInvalidateNeighbourhoodPerks()

  return useMutation({ mutationFn: deleteNeighbourhoodPerk, onSuccess: invalidatePerks })
}
